import { Sortable } from 'sortablejs';

let listWithHandle = document.querySelectorAll('.sortablelist');
[].forEach.call(listWithHandle, el => {
    Sortable.create(el, {
        handle: '.list-handle',
        animation: 300,
        ghostClass: 'sortable-selected',
        
        // autoscroll options
        scroll: true,
        forceFallback: true,
        forceAutoscrollFallback: true, // force autoscroll plugin to enable even when native browser autoscroll is available
        scrollSensitivity: 100, // px, how near the mouse must be to an edge to start scrolling.
        scrollSpeed: 5, // px, speed of the scrolling
        bubbleScroll: true // apply autoscroll to all parent elements, allowing for easier movement
    });
});

window.saveEventOrder = function(ul_element) {
    const elements = document.querySelectorAll(`${ul_element} li`);
    let new_order = [];

    elements.forEach(element => {
        // console.log(element.getAttribute('key'));
        new_order.push(element.getAttribute('key'));
    });

    console.log(new_order);

    return new_order;
}


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/sortable.js